export enum Probability {
  VERY_LOW = '445116',
  LOW = '445117',
  NEUTRAL = '445118',
  HIGH = '445119',
  VERY_HIGH = '445120',
}
